import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/external-data')({
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/external-data');
    const title = i18n.t('External Data | MINT');
    return { title };
  },
  head({ loaderData }) {
    const title = loaderData?.title;

    return {
      meta: [
        {
          title,
        },
      ],
    };
  },
});
